import { Box, Drawer, ModalProps, useMediaQuery } from '@mui/material';
// material-ui
import { useTheme } from '@mui/material/styles';
import { drawerWidth } from 'config';
import { useMemo } from 'react';
import DrawerContent from './DrawerContent';
// project import
import DrawerFooter from './DrawerFooter';
import DrawerHeader from './DrawerHeader';
import MiniDrawerStyled from './MiniDrawerStyled';

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

export interface MainDrawerProps {
    open?: boolean;
    handleDrawerToggle?: ModalProps['onClose'];
    window?: () => Window;
}

const MainDrawer: React.FC<MainDrawerProps> = ({ open, handleDrawerToggle, window }): JSX.Element => {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

    // responsive drawer container
    const container = window !== undefined ? () => window().document.body : undefined;

    // header content
    const drawerContent = useMemo(() => <DrawerContent />, []);
    const drawerHeader = useMemo(() => <DrawerHeader open={open} />, [open]);
    const drawerFooter = useMemo(() => <DrawerFooter open={open} />, [open]);

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} aria-label="mailbox folders">
            {!matchDownMD ? (
                <MiniDrawerStyled variant="permanent" open={open}>
                    {drawerHeader}
                    {drawerContent}
                    {!!drawerFooter && (
                        <>
                            <Box flex={1}></Box>
                            {drawerFooter}
                        </>
                    )}
                </MiniDrawerStyled>
            ) : (
                <Drawer
                    container={container}
                    variant="temporary"
                    open={open}
                    onClose={handleDrawerToggle}
                    ModalProps={{ keepMounted: true }}
                    sx={{
                        display: { xs: 'block', lg: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: drawerWidth,
                            borderRight: `1px solid ${theme.palette.divider}`,
                            backgroundImage: 'none',
                            boxShadow: 'inherit'
                        }
                    }}
                >
                    {open && drawerHeader}
                    {open && drawerContent}
                    {open && drawerFooter && (
                        <>
                            <Box flex={1}></Box>
                            {drawerFooter}
                        </>
                    )}
                </Drawer>
            )}
        </Box>
    );
};

export default MainDrawer;
